import React from 'react';
import {useNavigate} from 'react-router-dom';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AddToQueueIcon from '@mui/icons-material/AddToQueue';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';

const Home = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{width: '100%'}}>
      <Grid
        container
        spacing={3}
        style={{
          justifyContent: 'flex-start',
          alignItems: 'center',
          textAlign: 'center',
          padding: '1em 1em 1em 1em',
        }}
      >
        <Grid item xs={12}>
          <AddToQueueIcon/> Telemedicina
        </Grid>
        <Grid
          item
          xs={4}
        >
          <IconButton
            onClick={() => {
              navigate('/telemedicine/charges');
            }}
          >
            <Paper style={{
              padding: '1em 1em 1em 1em',
            }}>
              <Grid item xs={12}>
                <RequestQuoteIcon
                  fontSize='medium'
                />
              </Grid>
              <Grid item xs={12}>
               Cobrança
              </Grid>
            </Paper>
          </IconButton>
        </Grid>
        <Grid item xs={12}>
          <CloudQueueIcon/> PACS
        </Grid>
        <Grid
          item
          xs={4}
        >
          <IconButton
            onClick={() => {
              navigate('/pacs/charges');
            }}
          >
            <Paper style={{
              padding: '1em 1em 1em 1em',
            }}>
              <Grid item xs={12}>
                <RequestQuoteIcon
                  fontSize='medium'
                />
              </Grid>
              <Grid item xs={12}>
               Cobrança
              </Grid>
            </Paper>
          </IconButton>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Home;
